/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the type of time interval to consider to aggregate the values:
 *   * HOUR : hour
 *   * DAY : day
 */
export enum ExportRequestStateSampling {
  HOUR = 'HOUR',
  DAY = 'DAY'
}
